export default __webpack_public_path__ + "static/media/luminr-logo.9a586a04.svg";